export const environment = {
  apiURL: 'https://admin.visio.dev.br/api',
  token: 'tokenVisio',
  supabaseUrl: 'https://mwbuhplzbjoplmlywtqh.supabase.co',
  supabaseKey: 'sb_publishable_EAqnOBV06EldeB6seCZtkw_sNAVzYef',
  supabaseUserEmail: 'visio-dev@visio.ai',
  supabaseUserPwd: '@cH$svJuoUt8@P'
}
